import { render } from "./gsrbr0602.vue?vue&type=template&id=ffe5e70c&scoped=true"
import script from "./gsrbr0602.vue?vue&type=script&lang=js"
export * from "./gsrbr0602.vue?vue&type=script&lang=js"

import "./gsrbr0602.vue?vue&type=style&index=0&id=ffe5e70c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ffe5e70c"]])

export default __exports__